export default {
  'blog.eyebrow': 'Vietnam Story',
  'blog.title': 'Cẩm nang du lịch',
  'blog.subtitle': 'Chi phí thực tế, lộ trình thật và những người lên kế hoạch cho chúng. Được viết bởi chính các chuyên gia địa phương vận hành những chuyến đi này mỗi tuần.',
  'blog.home': 'Trang chủ',
  'blog.blog': 'Blog',
  'blog.searchPlaceholder': 'Tìm cẩm nang',
  'blog.searchAria': 'Tìm kiếm bài viết blog',
  'blog.loading': 'Đang tải cẩm nang...',
  'blog.loadFailed': 'Không thể tải cẩm nang.',
  'blog.tryAgain': 'Thử lại',
  'blog.latest': 'Cẩm nang mới nhất',
  'blog.noGuides': 'Không tìm thấy cẩm nang nào. Hãy thử tìm kiếm khác.',
  'blog.pagination': 'Phân trang',
  'blog.goToPage': 'Đi tới trang {{page}}',
  'blog.ctaTitle': 'Cần một lịch trình riêng?',
  'blog.ctaText': 'Hãy nói với chuyên gia địa phương điều bạn đang nghĩ. Họ sẽ gửi lại lộ trình được xây dựng theo ngày đi, nhịp độ và ngân sách của bạn, không phải một khuôn mẫu.',
  'blog.contactExpert': 'Liên hệ chuyên gia địa phương',
  'blog.newsTitle': 'Vẫn đang phân vân về lộ trình?',
  'blog.newsText': 'Đăng ký để nhận cẩm nang du lịch, mẹo địa phương và lời khuyên chân thực về Việt Nam vào hộp thư. Không bao giờ spam.',
  'blog.emailPlaceholder': 'Nhập email của bạn',
  'blog.subscribe': 'Đăng ký',
  'blog.subscribing': 'Đang đăng ký...',
  'blog.thanks': 'Cảm ơn bạn đã đăng ký! Hãy kiểm tra hộp thư để nhận mẹo du lịch.',
  'blog.invalidEmail': 'Vui lòng nhập địa chỉ email hợp lệ.',
  'blog.errorGeneric': 'Đã xảy ra lỗi. Vui lòng thử lại.',
  'blog.errorNetwork': 'Lỗi mạng. Vui lòng thử lại.',
  'blog.breadcrumb': 'Điều hướng',
  'blog.tableOfContents': 'Mục lục',
  'blog.faq': 'Câu hỏi thường gặp',
  'blog.loadingArticle': 'Đang tải bài viết...',
  'blog.couldNotLoadArticle': 'Không thể tải bài viết này',
  'blog.articleNotFound': 'Không tìm thấy bài viết',
  'blog.articleNotFoundText': 'Bài viết bạn đang tìm không tồn tại.',
  'blog.by': 'Bởi',
  'blog.sidebarTitle': 'Khám phá Việt Nam, không lo lắng',
  'blog.sidebarText': 'Cẩm nang chân thật, lộ trình thật và các chuyên gia địa phương lên kế hoạch. Được viết bởi chính những người vận hành những chuyến đi này mỗi tuần.',
  'blog.exploreTours': 'Khám phá các tour của chúng tôi',
  'blog.share': 'Chia sẻ',
  'blog.copyLink': 'Sao chép liên kết',
  'blog.shareFacebook': 'Chia sẻ lên Facebook',
  'blog.shareWhatsApp': 'Chia sẻ qua WhatsApp',
  'blog.heroAlt': 'Vietnam Story - Cẩm nang du lịch',
  'blog.captchaRequired': 'Vui lòng xác nhận bạn không phải robot.',
  'blog.captchaFailed': 'Xác minh bảo mật thất bại. Vui lòng thử lại.',
};